import Date from "../../../../components/Date/Date"

function RecentlyInactiveCustomerTableRow({row}: any) {
  return (
    <tr>
      <td>
        <div>{row?.['customerName']}</div>
      </td>
      <td>
        <div>{row?.['customerEmail']}</div>
      </td>
      <td>
        <div>{row?.['customerRepresentative']}</div>
      </td>
      <td>
        <div>{row?.['customerGroupName']}</div>
      </td>
      <td>
        <div>{row?.['totalOrders']}</div>
      </td>
      <td>
        <Date date={row?.['orderDate']} />
      </td>
      <td>
        <Date date={row?.['customerDateCreated']} />
      </td>
    </tr>
  )
}

export default RecentlyInactiveCustomerTableRow
